import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { QUERY_KEY } from "@/modules/grupos-diagnostico/components/grupos-diagnostico-table/GruposDiagnosticoTable";
import { getGrupoArray } from "@/modules/grupos-diagnostico/firestore";

type TGetGroupResponse = Awaited<ReturnType<typeof getGrupoArray>>;

/**
 * Get ideia from url params
 * @param id - id do questionario
 * @param id.id - id do questionario
 * @param id.activeEmpresaId - empresa selecionada
 * @returns - Ideia or null if not found
 */
// prettier-ignore
function useQueryGroupConvite({ id, activeEmpresaId }: { id: string | undefined; activeEmpresaId: string | undefined }) {
  // const activeEmpresaId = convite?.idEmpresa/* useUserStore((state) => state.activeEmpresaId) */;
  return useQuery<TGetGroupResponse, FirestoreError, TGruposDiagnostico[]>({
    queryKey: [QUERY_KEY, id, activeEmpresaId],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      if (!id) {
        throw new Error("Nenhum questionario");
      }

      return getGrupoArray(activeEmpresaId, id);
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }

      return dataResponse.docs.map((document_) => document_.data());
    },
    enabled: !!id && !!activeEmpresaId
  });
}

export default useQueryGroupConvite;
